import axios from "axios";
import * as d3 from "d3";
import {inrFormatter} from '../functions'
import * as dc from 'dc';
import crossfilter from "crossfilter";


export default function (chart, divId, vizName) {
    var url = '/api/fetchData/' + chart.data.syspk + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.get(url).then(res => {
        let data = res.data;
        console.warn("divId:", divId)

        var timeChart = dc.barChart("#year");
        var categoryChart = dc.barChart("#category");
        var countChart = dc.barChart("#orders");
        var salesmanChart = dc.barChart("#salesman");
        var dataTable = dc.dataTable("#table-graph");

        //Run the data through crossfilter
        var salesman = crossfilter(data);  // Gets our 'salesman' into crossfilter

        /******************************************************
         * Create the Dimensions                               *
         * A dimension is something to group or filter by.     *
         * Crossfilter can filter by exact value, or by range. *
         ******************************************************/

        var year_month_dim = salesman.dimension((d) => {
            return d.dim1_id
        });
        var year_month_rev = year_month_dim.group().reduceSum((d) => {
            return d.metric2;
        });

        var category_dim = salesman.dimension((d) => {
            return d.dim3_id;
        })
        var category_rev = category_dim.group().reduceSum((d) => d.metric2);

        var order_dim = salesman.dimension((d) => {
            return d.metric1;
        });
        var order_rev = order_dim.group().reduceSum((d) => {
            return d.metric3;
        });

        var salesman_dim = salesman.dimension((d) => {
            return d.dim2_id;
        })
        var salesman_rev = salesman_dim.group().reduceSum((d) => d.metric2);

        timeChart.yAxis().tickFormat(inrFormatter)
        categoryChart.yAxis().tickFormat(inrFormatter)
        countChart.yAxis().tickFormat(inrFormatter)
        salesmanChart.yAxis().tickFormat(inrFormatter)

        // Create the Visualisations
        timeChart.width(chart.width)
            .height(chart.height)
            .margins(chart.margin)
            .dimension(year_month_dim)
            .group(year_month_rev)
            .transitionDuration(500)
            .centerBar(true)
            .gap(1)
            .elasticY(true)
            .x(d3.scaleLinear()
                .domain([(d3.min(data, d => {
                    return d.dim1_id
                })), d3.max(data, d => {
                    return d.dim1_id
                })])) // scale and domain of the graph
            .xAxis();

        categoryChart.width(chart.width)
            .height(chart.height)
            .margins(chart.margin)
            .dimension(category_dim)
            .group(category_rev)
            .transitionDuration(500)
            .centerBar(true)
            .gap(1)  // bar width Keep increasing to get right then back off.
            .x(d3.scaleLinear()
                .domain([(d3.min(data, d => {
                    return d.dim3_id
                })), d3.max(data, d => {
                    return d.dim3_id
                })]))
            .elasticY(true)
            .xAxis()
            .ticks(10);

        countChart.width(chart.width)
            .height(chart.height)
            .margins(chart.margin)
            .dimension(order_dim)
            .group(order_rev)
            .transitionDuration(500)
            .centerBar(true)
            .gap(1)  // bar width Keep increasing to get right then back off.
            .x(d3.scaleLinear()
                .domain([(d3.min(data, d => {
                    return d.metric1
                })), d3.max(data, d => {
                    return d.metric1
                })]))
            .elasticY(true)
            .xAxis()
            .ticks(10);

        salesmanChart.width(chart.width)
            .height(chart.height)
            .margins(chart.margin)
            .dimension(salesman_dim)
            .group(salesman_rev)    // the values on the y axis
            .transitionDuration(500)
            .centerBar(true)
            .gap(1)   // bar width Keep increasing to get right then back off.
            .x(d3.scaleLinear()
                .domain([(d3.min(data, d => {
                    return d.dim2_id
                })), d3.max(data, d => {
                    return d.dim2_id
                })]))
            .elasticY(true)
            .xAxis()
            .tickFormat(inrFormatter);

        dataTable.width(chart.width)
            .height(chart.height)
            .dimension(year_month_dim)
            .size(chart.vizSpecific1)    // number of rows to return
            .columns([
                (d) => {
                    return d.dim1_name;
                },
                (d) => {
                    return d.dim2_name;
                },
                (d) => {
                    return d.dim3_name;
                },
                (d) => {
                    return inrFormatter(d.metric1);
                },
                (d) => {
                    return inrFormatter(d.metric2);
                },
                (d) => {
                    return inrFormatter(d.metric3);
                },
            ])
            .sortBy((d) => {
                return d.dim1_name;
            })
        //.order(d3.ascending);

        //Render the Charts
        dc.renderAll();
    })
}
